import React, { useState, useContext } from 'react';
import CustomDialog from '../ui/feedback/CustomDialog';
import { sleep } from '../../scripts/common/helper.js';
import { WebSocketContext } from '../../context/WebSocketContext.js';
import * as PwaEvents from '../../context/PwaEvents.js';
import { AssessmentContext } from '../../context/AssessmentContext.js';
import { KioskContext } from '../../context/KioskProviderContext.js';
import { useTranslation } from 'react-i18next';

/**
 *
 * @param {Object} props The properties for the component
 * @param {boolean} props.message Message to display in the dialog.
 * @param {boolean} props.title Title of the dialog
 * @returns
 */
const AwaitingAuthorizationDialog = () => {
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const { sendMsgToWebsocket } = useContext(WebSocketContext);
  const { setExit } = useContext(AssessmentContext);
  const { isSecure } = useContext(KioskContext);
  const { t } = useTranslation();

  //Dialog actions for Awaiting authorization
  const AWAITING_AUTH_ACTIONS = [
    {
      label: t('common.cancel'),
      handle: () => {
        setOpenConfirmation(true);
      },
    },
  ];

  const [awaitAuthDialogProps, setAuthDialogProps] = useState({
    title: t('components.awaitingAuthorizationDialog.title'),
    message: isSecure
      ? t('components.awaitingAuthorizationDialog.waitingMessage')
      : `${t('components.awaitingAuthorizationDialog.waitingMessage')}\n ${t('components.awaitingAuthorizationDialog.fullscreenWarning')}`,
    actions: AWAITING_AUTH_ACTIONS,
  });

  //Dialog actions for cancel awaiting confirmation
  const AWAITING_AUTH_CANCEL_CONFIRMATION_ACTIONS = [
    {
      label: t('common.yes'),
      handle: async () => {
        setOpenConfirmation(false);
        setAuthDialogProps({
          title: t('components.awaitingAuthorizationDialog.title'),
          message: t('components.awaitingAuthorizationDialog.cancelling'),
        });

        //Send abort message
        sendMsgToWebsocket(PwaEvents.PWA_AUTH_CANCEL);

        //Sleep for 3 seconds
        await sleep(3000);

        //Clear storage and redirect back to login screen
        setExit(true);
      },
    },
    {
      label: t('components.awaitingAuthorizationDialog.continueWaiting'),
      handle: () => {
        setOpenConfirmation(false);
      },
    },
  ];

  return (
    <>
      {openConfirmation && (
        <CustomDialog
          open={true}
          dialogProps={{
            title: t('components.awaitingAuthorizationDialog.cancelAuthorization'),
            message: t('components.awaitingAuthorizationDialog.cancelWarning'),
            actions: AWAITING_AUTH_CANCEL_CONFIRMATION_ACTIONS,
          }}
          dialogSx={{
            zIndex: (theme) => theme.zIndex.modal + 1
          }}
        />
      )}
      <CustomDialog open={true} dialogProps={awaitAuthDialogProps} />
    </>
  );
};

export default AwaitingAuthorizationDialog;
